//import { useHistory } from "react-router-dom";
//import { useCancelToken } from "../../hooks/general/useCancelToken";
//import { getIdToken } from "../../libs/auth";
import {locationStrings as strings} from "../../resources/strings/locations";
import {BreadcrumbHeader} from "../general/BreadcrumbHeader";

export const LocationBreadcrumbHeader = () => {
  return <BreadcrumbHeader header={strings.header.locationList} children={<div></div>} hideBgColor={true} spacing={1.1} />;
};
